import { DataGrid, mergeSx, type DataGridProps } from '@shared/components';

import { columns } from './columns';

export type AdminQuestionnaireExportDataGridProps = Omit<DataGridProps, 'columns'>;

export default function AdminQuestionnaireExportDataGrid(
  props: Readonly<AdminQuestionnaireExportDataGridProps>,
) {
  const { sx, ...restProps } = props;
  return (
    <DataGrid
      columns={columns}
      rowHeight={48}
      disableColumnMenu
      sx={mergeSx(
        (theme) => ({
          bgcolor: theme.palette.background.paper,
          '.MuiDataGrid-columnHeaders': {
            bgcolor: theme.palette.grey[100],
            borderColor: theme.palette.grey[300],
          },
          '.MuiDataGrid-columnHeader': {
            px: theme.spacing(3),
          },
          '& .MuiDataGrid-row .MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-row': {
            borderBottom: '1px solid',
            borderColor: theme.palette.grey[300],
          },
          '& .MuiDataGrid-row--lastVisible': {
            borderBottom: 'none',
          },
          border: '1px solid',
          borderColor: theme.palette.grey[300],
          '--DataGrid-overlayHeight': '412px',
        }),
        sx,
      )}
      {...restProps}
    />
  );
}
